import api from './api';

export default async function saveActiveTemplate( taskType, body) {

    const { data } = await api.post(
        `arc-automarker/templates/${taskType}`,
        body
    );

    return data;
}